import React, {Suspense, lazy} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {FallbackView} from '../../_metronic/partials'
import {DashboardWrapper} from '../pages/dashboard/DashboardWrapper'
import {
  PATH_CALL_TRACKING,
  PATH_CONTACTS,
  PATH_MAILING,
  PATH_NATURAL_REFERENCING, PATH_PROFILE, PATH_REPORT, PATH_SUPPORT,
  PATH_WEB_FORMS, PATH_UPDATE_PLUGINS,
  ROOTS_DASHBOARD, PATH_CONVERSION_CLICK,
} from './paths'

export function PrivateRoutes() {

  // CALL-TRACKING
  const CallTrackingPage = lazy(() => import('../pages/call-tracking/CallTrackingPage'))

  // WEB-FORMS
  const WebFormsPage = lazy(() => import('../pages/web-forms/WebFormsPage'))

  // CONTACTS
  const ContactsPage = lazy(() => import('../pages/contacts/ContactsPage'))

  // MAILING
  const MailingPage = lazy(() => import('../pages/mailing/MailingPage'))

  // NATURAL REFERENCING
  const NaturalReferencing = lazy(() => import('../pages/natural-referencing/NaturalReferencingPage'))

  // ACCOUNT
  const AccountPage = lazy(() => import('../modules/account/AccountPage'))

  // WORDPRESS-UPDATES
  const WordpressUpdatesPage = lazy(() => import('../pages/wordpress-updates/WordpressUpdatesPage'))

  // REPORT
  const ReportPage = lazy(() => import('../pages/report/ReportPage'))

  // SAV
  const SAVPage = lazy(() => import('../pages/sav/SAVPage'))

  // CONVERSION-CLICKS
  const ConversionClicksPage = lazy(() => import('../pages/conversion-clicks/ConversionClickPage'))

  return (
    <Suspense fallback={<FallbackView />}>
      <Switch>

        <Route path={ROOTS_DASHBOARD} component={DashboardWrapper} />
        <Route path={PATH_CALL_TRACKING.root} component={CallTrackingPage} />
        <Route path={PATH_WEB_FORMS.root} component={WebFormsPage} />
        <Route path={PATH_CONTACTS.root} component={ContactsPage} />
        <Route path={PATH_MAILING.root} component={MailingPage} />
        <Route path={PATH_NATURAL_REFERENCING.root} component={NaturalReferencing} />
        <Route path={PATH_PROFILE.root} component={AccountPage} />
        <Route path={PATH_UPDATE_PLUGINS.root} component={WordpressUpdatesPage} />
        <Route path={PATH_REPORT.root} component={ReportPage} />
        <Route path={PATH_SUPPORT.root} component={SAVPage} />
        <Route path={PATH_CONVERSION_CLICK.root} component={ConversionClicksPage} />

        <Redirect from="/auth" to={ROOTS_DASHBOARD} />
        <Redirect exact from="/" to={ROOTS_DASHBOARD} />
        <Redirect to="error/404" />
      </Switch>
    </Suspense>
  )
}
